// SPDX-License-Identifier: MIT
// Wires a checkout CTA button to the Mollie checkout (CP-2). On click →
// startCheckout(sku):
//   • ok        → the browser is already navigating to Mollie's hosted checkout
//   • need_auth → dispatch a 'genesis:need-auth' event so main.ts opens the
//                 sign-in modal (the visitor must be signed in to attach a JWT)
//   • error     → onError callback (inline notice), button re-enabled
// Guards against double-submit via aria-busy (set synchronously before the await).
import { startCheckout } from './start';

export function wireCheckoutCta(
  btn: HTMLElement,
  sku: string,
  onError?: (reason: string) => void,
): void {
  btn.addEventListener('click', () => {
    void run();
  });

  async function run(): Promise<void> {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    const r = await startCheckout(sku);
    if (r.ok) return; // navigating away to Mollie — leave the button busy
    btn.removeAttribute('aria-busy');
    if (r.reason === 'need_auth') {
      window.dispatchEvent(new CustomEvent('genesis:need-auth', { detail: { sku } }));
    } else {
      onError?.(r.reason);
    }
  }
}
